<template>
    <section class="bg-[#385A23] lg:py-16 py-10 lg:px-16 px-6">
        <div class="grid grid-cols-11 lg:gap-x-16">
            <div class="col-span-12 lg:col-span-6">
                <div class="text-4xl text-center text-white xl:text-38 lg:text-left font-ww-bold" v-html="title">
                </div>

                <div class="grid">
                    <div class="lg:mt-10 mt-5 text-xl text-white md-max:!leading-8 font-ww-regular xl:text-xl md:text-lg xl:!leading-8 lg:order-1 order-2"
                        v-html="text1">
                    </div>

                    <div class="mt-10 lg:order-2 order-1">
                        <nuxt-img :src="image1" alt="From Our Farm to Your Cup" width="474" height="343"
                            class="mx-auto w-full rounded-lg" loading="lazy" format="webp"
                            sizes="xs:330px sm:440px md:745vw lg:388px xl:474px" />
                    </div>
                </div>

            </div>

            <div class="flex flex-col col-span-12 gap-y-10 mt-10 lg:mt-20 md-max:gap-y-6 lg:col-span-5">
                <div class="">
                    <nuxt-img :src="image2" alt="From Our Farm to Your Cup" width="404" height="310"
                        class="mx-auto w-full rounded-lg" loading="lazy" format="webp"
                        sizes="xs:330px sm:440px md:745vw lg:388px xl:404px" />
                </div>

                <div class="lg:mt-0 text-xl text-white font-ww-regular md-max:!leading-8 xl:text-xl md:text-lg xl:!leading-8"
                    v-html="text2">
                </div>

            </div>

        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: 'From Our Farm to Your Cup'
    },
    text1: {
        type: String,
        default: 'High above sea level, in the verdant highlands of Nueva Segovia, lies La Esperanza Farm. Here, Oscar Flores Cruz cultivates Caturra and Catimor coffee on eight hectares (approx the size of 8 football fields) of dreams, ambition, and love. Oscar\'s journey began in 2000, not from legacy, but from humble beginnings and relentless determination.<br/><br/>Coffee is not just a job for Oscar, it\'s his lifeblood, a magical elixir that nourishes his family. He finds joy in the continuous work, the harvest, the washing, and drying of beans. His farm, La Esperanza, or \'The Hope,\' embodies his dreams and aspirations. The name signifies his unyielding faith that through coffee, he would achieve his goals.'
    },
    image1: {
        type: String,
        default: '/assets/images/IMG_2312.jpg'
    },
    image2: {
        type: String,
        default: '/assets/images/IMG_2287.jpg'
    },
    text2: {
        type: String,
        default: 'The upcoming harvest promises prosperity and the fulfillment of a long-held dream: building his house. Each coffee bean from La Esperanza is a testament to their unwavering commitment to quality. Despite the challenges of climate change and financial constraints, Oscar remains resilient and hopeful.<br/><br/>To the potential buyer, Oscar offers a coffee that is not just excellent and healthy, but a cup filled with a story of resilience, passion, and hope. From the heights of Nueva Segovia to your cup, Oscar invites you to share in the journey of La Esperanza.'
    }
})

defineBuilderComponent({
    friendlyName: "Image Text Grid New",
    inputs: [
        {
            name: 'title',
            type: 'text',
            defaultValue: 'From Our Farm to Your Cup',
            friendlyName: 'Title'
        },
        {
            name: 'text1',
            type: 'richText',
            defaultValue: 'High above sea level, in the verdant highlands of Nueva Segovia, lies La Esperanza Farm. Here, Oscar Flores Cruz cultivates Caturra and Catimor coffee on eight hectares (approx the size of 8 football fields) of dreams, ambition, and love. Oscar\'s journey began in 2000, not from legacy, but from humble beginnings and relentless determination.<br/><br/>Coffee is not just a job for Oscar, it\'s his lifeblood, a magical elixir that nourishes his family. He finds joy in the continuous work, the harvest, the washing, and drying of beans. His farm, La Esperanza, or \'The Hope,\' embodies his dreams and aspirations. The name signifies his unyielding faith that through coffee, he would achieve his goals.',
            friendlyName: 'First Text Block'
        },
        {
            name: 'image1',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/IMG_2312.jpg',
            friendlyName: 'First Image'
        },
        {
            name: 'image2',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/IMG_2287.jpg',
            friendlyName: 'Second Image'
        },
        {
            name: 'text2',
            type: 'richText',
            defaultValue: 'The upcoming harvest promises prosperity and the fulfillment of a long-held dream: building his house. Each coffee bean from La Esperanza is a testament to their unwavering commitment to quality. Despite the challenges of climate change and financial constraints, Oscar remains resilient and hopeful.<br/><br/>To the potential buyer, Oscar offers a coffee that is not just excellent and healthy, but a cup filled with a story of resilience, passion, and hope. From the heights of Nueva Segovia to your cup, Oscar invites you to share in the journey of La Esperanza.',
            friendlyName: 'Second Text Block'
        }
    ]
});
</script>
